"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelSizesTemplate = exports.RatingTypesTemplate = exports.PILL_RATING = exports.STAR_RATING_EMPTY_STATE = exports.STAR_RATING_FILLED = exports.STAR_RATING = void 0;

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var STAR_RATING = 'STAR_RATING';
exports.STAR_RATING = STAR_RATING;
var STAR_RATING_FILLED = 'STAR_RATING_FILLED';
exports.STAR_RATING_FILLED = STAR_RATING_FILLED;
var STAR_RATING_EMPTY_STATE = 'STAR_RATING_EMPTY_STATE';
exports.STAR_RATING_EMPTY_STATE = STAR_RATING_EMPTY_STATE;
var PILL_RATING = 'PILL_RATING';
exports.PILL_RATING = PILL_RATING;
var RatingTypesTemplate = {
  STAR_RATING: {
    checkedColor: _colors.MARIGOLD,
    uncheckedColor: _colors.FLINT,
    checkedIcon: 'favorite',
    uncheckedIcon: 'favoriteHollow'
  },
  STAR_RATING_FILLED: {
    checkedColor: _colors.MARIGOLD,
    uncheckedColor: _colors.GREAT_WHITE,
    checkedIcon: 'favorite',
    uncheckedIcon: 'favorite'
  },
  STAR_RATING_EMPTY_STATE: {
    checkedColor: _colors.GREAT_WHITE,
    uncheckedColor: _colors.GREAT_WHITE,
    checkedIcon: 'favorite',
    uncheckedIcon: 'favorite'
  },
  PILL_RATING: {
    checkedColor: _colors.SLINKY,
    uncheckedColor: _colors.GREAT_WHITE,
    checkedIcon: 'minus',
    uncheckedIcon: 'minus'
  }
};
exports.RatingTypesTemplate = RatingTypesTemplate;
var LabelSizesTemplate = {
  sm: _sizes.MICROCOPY_SIZE,
  small: _sizes.MICROCOPY_SIZE,
  md: _sizes.BASE_FONT_SIZE,
  medium: _sizes.BASE_FONT_SIZE,
  large: _sizes.ROOT_FONT_SIZE,
  lg: _sizes.ROOT_FONT_SIZE
};
exports.LabelSizesTemplate = LabelSizesTemplate;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/RatingTypes.js
// module id = 125
// module chunks = 209 210 211 212